import { Form } from '@amzn/storm-ui-column-form-kit';

import { CustomConfirmationModal } from '../../../../UiComponentsLibrary/CustomConfirmationModal';
import { useCreateDetailedBookingSOVForm } from '../hooks/useCreateDetailedBookingSOVForm';
import { CreateDetailedBookingSOVFormProps } from '../interface/DetailedBookingInterface';
import ContextualNodesSectionSOV from './SOVFormComponents/ContextualNodesSectionSOV';
import SOVMainForm from './SOVFormComponents/SOVMainForm';

const CreateDetailedBookingSOVForm = (
  props: CreateDetailedBookingSOVFormProps
) => {
  const {
    modalProps,
    sovMainFormProps,
    isContextualSelected,
    contextualNodesSectionProps,
  } = useCreateDetailedBookingSOVForm(props);

  return (
    <>
      <Form id="detailed-booking-sov-form">
        <SOVMainForm {...sovMainFormProps} />
        {isContextualSelected && (
          <ContextualNodesSectionSOV {...contextualNodesSectionProps} />
        )}
      </Form>
      <CustomConfirmationModal {...modalProps} />
    </>
  );
};

export default CreateDetailedBookingSOVForm;
